var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWhiteGoogle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.3473 10.7142C19.3465 10.1088 19.296 9.50442 19.1963 8.90723H10.1963V12.4972H15.3543C15.241 13.0754 15.0137 13.6252 14.6856 14.1145C14.3575 14.6039 13.9352 15.0229 13.4433 15.3472V17.7352H16.5163C17.452 16.8273 18.1873 15.7336 18.6749 14.5244C19.1625 13.3152 19.3915 12.0173 19.3473 10.7142Z",
    fill: "#4285F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2002 20.0522C12.5231 20.1143 14.7819 19.2853 16.5132 17.7352L13.4382 15.3472C12.4742 15.9707 11.346 16.2921 10.1982 16.2702C9.00392 16.256 7.84425 15.8674 6.88262 15.1591C5.92099 14.4507 5.20591 13.4585 4.83817 12.3222H1.67017V14.7822C2.46268 16.3658 3.68038 17.6976 5.1869 18.6283C6.69343 19.5591 8.42931 20.0521 10.2002 20.0522Z",
    fill: "#34A853"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.84222 12.3222C4.64094 11.7356 4.53953 11.1194 4.54222 10.4992C4.54346 9.87939 4.64476 9.26381 4.84222 8.67625V6.21625H1.67422C0.999033 7.54299 0.647126 9.01058 0.647217 10.4992C0.647126 11.9879 0.999033 13.4555 1.67422 14.7822L4.84222 12.3222Z",
    fill: "#FBBC05"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2003 4.72724C11.5618 4.70531 12.8773 5.22007 13.8623 6.16023L16.5853 3.43723C14.8612 1.80924 12.5714 0.915593 10.2003 0.945234C8.43014 0.946055 6.69511 1.43943 5.18935 2.37015C3.6836 3.30087 2.46653 4.63222 1.67432 6.21523L4.84232 8.67523C5.20995 7.53925 5.92473 6.54724 6.88596 5.83896C7.84719 5.13069 9.00642 4.74185 10.2003 4.72724Z",
    fill: "#EA4335"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteGoogle);
export default __webpack_public_path__ + "static/media/white_google.5c7456ad51f0e42e15e139c65d678d34.svg";
export { ForwardRef as ReactComponent };